import Reveal from "../Plan2Benefit/Reveal.jsx";
import SectionHeading from "../Plan2Benefit/SectionHeading.jsx";
import { comparisonRows, cxNote } from "./data.js";

/* ─────────────────────────────────────────────────────────────
   WhyNotJust ("Why us") — the fork: running everywhere yourself,
   vs. one Car Plan. The "With Plan2Benefit" column carries the
   only gradient fill in this section, so it reads as the answer
   at a glance even before anyone reads the row copy.
───────────────────────────────────────────────────────────── */
export default function WhyNotJust() {
  return (
    <section id="why-us" className="bg-white px-4 py-16 sm:px-6 lg:px-8 lg:py-28">
      <div className="mx-auto max-w-4xl">
        <Reveal>
          <SectionHeading
            eyebrow="Why us"
            title="Buying a car shouldn't mean"
            highlight="running everywhere."
          />
        </Reveal>

        <Reveal delay={0.08}>
          <div className="mt-12 overflow-hidden rounded-[20px] border border-[#eceafb]">
            {/* grid-cols-2 on mobile (label collapses into its own row per
                item below) / grid-cols-[1.1fr_1fr_1fr] from sm — header and
                rows must switch at the same breakpoint or the two columns
                stop lining up. */}
            <div className="grid grid-cols-2 sm:grid-cols-[1.1fr_1fr_1fr]">
              <div className="hidden bg-[#faf9ff] sm:block" />
              <div className="bg-[#faf9ff] px-5 py-4 font-montserrat text-[11px] font-bold uppercase tracking-[0.1em] text-[#0d0828]/45 sm:border-l sm:border-[#eceafb]">
                Without Plan2Benefit
              </div>
              <div className="border-l border-[#eceafb] bg-gradient-to-br from-[#4328E7] to-[#6d63ff] px-5 py-4 font-montserrat text-[11px] font-bold uppercase tracking-[0.1em] text-white">
                With Plan2Benefit
              </div>
            </div>

            {comparisonRows.map((row) => (
              <div
                key={row.label}
                className="grid grid-cols-2 border-t border-[#eceafb] transition-colors duration-300 hover:bg-[#faf9ff] sm:grid-cols-[1.1fr_1fr_1fr]"
              >
                <div className="col-span-2 px-5 pb-1.5 pt-4 font-montserrat text-[13.5px] font-bold text-[#0d0828] sm:col-span-1 sm:py-4">
                  {row.label}
                </div>
                <div className="px-5 pb-4 pt-1.5 font-montserrat text-[13.5px] leading-6 text-[#0d0828]/40 line-through decoration-[#0d0828]/25 sm:border-l sm:border-[#eceafb] sm:py-4">
                  {row.without}
                </div>
                <div className="relative border-l border-[#eceafb] bg-[#4328E7]/[0.05] px-5 pb-4 pt-1.5 font-montserrat text-[13.5px] font-semibold leading-6 text-[#0d0828] sm:py-4">
                  <span className="absolute inset-y-0 left-0 w-[2px] bg-gradient-to-b from-[#4328E7] to-[#24BF9B]" />
                  {row.withUs}
                </div>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.14}>
          <p className="mt-9 font-montserrat text-[1.35rem] font-black tracking-[-0.02em] text-[#0d0828] sm:text-[1.6rem]">
            One Car Plan. One place to manage it.
          </p>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="mt-8 rounded-[16px] border border-[#eceafb] border-l-[3px] border-l-[#4328E7] bg-[#faf9ff] px-6 py-6 sm:px-7">
            <span className="font-montserrat text-[10.5px] font-bold uppercase tracking-[0.14em] text-[#4328E7]">
              Why this matters
            </span>
            <p className="mt-3 font-montserrat text-[14px] leading-7 text-[#0d0828]/65">
              {cxNote}
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
